(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection"] && !Shopify.designMode) return;
  try {
    
(function() {

  // ── Sort: auto-submit on change ──
  document.querySelectorAll('.toolbar-sort__select').forEach(function(select) {
    select.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  });

  // ── Filter drawer toggle ──
  document.querySelectorAll('.toolbar-btn--filters').forEach(function(btn) {
    var drawerId = btn.getAttribute('aria-controls');
    var drawer   = document.getElementById(drawerId);
    if (!drawer) return;

    btn.addEventListener('click', function() {
      var isOpen = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!isOpen));
      drawer.setAttribute('aria-hidden', String(isOpen));
    });
  });

  // ── Filter group collapse toggles ──
  document.querySelectorAll('.cg-filter-group__toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      var panelId    = this.getAttribute('aria-controls');
      var panel      = document.getElementById(panelId);
      this.setAttribute('aria-expanded', String(!isExpanded));
      if (panel) {
        if (isExpanded) { panel.setAttribute('hidden', ''); }
        else            { panel.removeAttribute('hidden'); }
      }
    });
  });

  // ── Filter form: submit navigates to filtered URL ──
  document.querySelectorAll('.cg-filter-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var params   = new URLSearchParams();
      var formData = new FormData(form);

      // Checked checkboxes
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
        params.append(cb.name, cb.value);
      });
      // Price inputs
      form.querySelectorAll('input[type="number"]').forEach(function(inp) {
        if (inp.value !== '') params.set(inp.name, inp.value);
      });
      // sort_by
      var sortInput = form.querySelector('input[name="sort_by"]');
      if (sortInput && sortInput.value) params.set('sort_by', sortInput.value);

      window.location.href = window.location.pathname + '?' + params.toString();
    });
  });

})();

  } catch(e) { console.error(e); }
})();
})();
